import { render } from "./FarmerDisplay.vue?vue&type=template&id=6067d8d5&ts=true"
import script from "./FarmerDisplay.vue?vue&type=script&lang=ts"
export * from "./FarmerDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__